import Joi from 'joi-browser';
import { INDUSTRY } from '../roanConstants';
import { PREFECTURE_GROUPS } from '../constants';
import regex from '../validateRegex';

const companyBranchPermissionCommonSchema = {
  permitted_source_section: Joi.required().disallow(null, '', 0, '0'),
  prefectures_code_id: Joi.when('permitted_source_section', {
    is: INDUSTRY.permissions.source[2].id,
    then: Joi.required().disallow(null, '', '0', 0),
  }),
  regional_development_bureau_id: Joi.when('prefectures_code_id', {
    is: PREFECTURE_GROUPS.hokkaido_tohoku.prefectures.hokkaido.id,
    then: Joi.required(),
  }),
  construction_industry_permission_section: Joi.required().disallow(
    null,
    '',
    0,
    '0'
  ),
  permission_number_l: Joi.string()
    .regex(regex.pattern.integerNoSign)
    .max(2),
  permission_number_r: Joi.string()
    .regex(regex.pattern.integerNoSign)
    .max(20),
  license_update_date: Joi.required(),
};

export default companyBranchPermissionCommonSchema;



// WEBPACK FOOTER //
// ./src/utilities/validationSchemas/companyBranchPermissionCommonSchema.js